<template>
  <div class="root-box">
    <div class="query-container">
      <el-form size="small" :inline="true">
        <el-form-item label="场景：">
          <el-input v-model="params.scene" style="width: 140px"></el-input>
        </el-form-item>

        <el-form-item label="活动标记：">
          <el-input v-model="params.campaignTag" style="width: 140px"></el-input>
        </el-form-item>

        <el-form-item label="生成时间：">
          <el-date-picker
            placeholder="选择时间"
            v-model="params.startTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            style="width: 184px"
          ></el-date-picker
          >至
          <el-date-picker
            placeholder="选择时间"
            v-model="params.endTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            style="width: 184px"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="是否查看：" @change="query">
          <el-select v-model="params.viewed" placeholder="请选择" clearable style="width: 120px">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否删除：" @change="query">
          <el-select v-model="params.deleted" placeholder="请选择" clearable style="width: 120px">
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button style="width: 100px; margin-right: 20px" type="primary" @click="query()"
            >查询</el-button
          >
        </el-form-item>

        <el-form-item style="float: right">
          <el-button style="width: 100px" type="primary" @click="openForm()">添加记录</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <el-table :data="list" stripe max-height="600">
        <el-table-column
          label="序号"
          type="index"
          show-overflow-tooltip
          width="50"
        ></el-table-column>
        <el-table-column prop="scene" label="场景"></el-table-column>
        <el-table-column prop="sceneDesc" label="场景描述"></el-table-column>
        <el-table-column prop="orderId" label="订单ID"></el-table-column>
        <el-table-column prop="campaignId" label="活动ID"></el-table-column>
        <el-table-column prop="campaignTag" label="活动标记"></el-table-column>
        <el-table-column prop="validOn" label="有效期起"></el-table-column>
        <el-table-column prop="validOff" label="有效期止"></el-table-column>
        <!-- <el-table-column prop="configId" label="配置ID"></el-table-column> -->
        <el-table-column prop="qrCode" label="二维码链接"> </el-table-column>
        <el-table-column prop="viewed" label="是否查看">
          <template slot-scope="scope">
            {{ scope.row.viewed ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="deleted" label="是否删除">
          <template slot-scope="scope">
            {{ scope.row.deleted ? "是" : "否" }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="deleteRecord(scope.row)">删除</el-button>
            <el-button
              v-if="scope.row.orderId"
              type="text"
              size="small"
              v-goRouteDetail="scope.row.orderId"
              >订单</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :current-page="currentPage"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="visible" width="600px" title="记录信息" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="150px" :size="size" :rules="rules">
        <el-form-item label="场景：" prop="scene">
          <el-input v-model="form.scene"></el-input>
        </el-form-item>

        <el-form-item label="场景描述：" prop="sceneDesc">
          <el-input v-model="form.sceneDesc"></el-input>
        </el-form-item>

        <el-form-item label="活动：" prop="campaignId">
          <el-select
            v-model="form.campaignId"
            placeholder="请选择活动"
            @change="handleCampaignChange"
            filterable
          >
            <el-option
              v-for="item in campaignList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              <span>{{ item.name }} 【{{ item.tag }}】</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="活动标记：" prop="campaignTag">
          <el-input v-model="form.campaignTag" disabled></el-input>
        </el-form-item>

        <el-form-item label="有效期起：" prop="validOn">
          <el-date-picker
            v-model="form.validOn"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="有效期止：" prop="validOff">
          <el-date-picker
            v-model="form.validOff"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="warning" :size="size" @click="saveOrUpdate">保存</el-button>
        <el-button type="info" :size="size" @click="visible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  listContactWayState,
  createContactWayState,
  delContactWayState,
  listCampaign
} from "@/api";
import { Toolkit } from "@/util";

export default {
  created() {
    this.query();
    this.loadCampaignList();
  },
  computed: {
    ...mapState({
      size: (state) => state.btnSize
    })
  },
  data() {
    return {
      visible: false,
      list: [],
      form: {},
      params: {
        deleted: false
      },
      total: 0,
      currentPage: 1,
      rules: {
        scene: [{ required: true, message: "请输入场景", trigger: "blur" }],
        sceneDesc: [{ required: true, message: "请输入场景描述", trigger: "blur" }]
      },
      campaignList: []
    };
  },
  methods: {
    query(page = 1) {
      const param = {
        page: {
          current: page
        },
        startTime: this.params.startTime,
        endTime: this.params.endTime,
        param: Toolkit.filterEmpty(this.params)
      };
      listContactWayState(param).then((res) => {
        const { records = [], current = 1, total = 0 } = res.data || {};
        this.list = records;
        this.currentPage = current;
        this.total = total;
      });
    },
    openForm(item) {
      this.visible = true;
      if (item) {
        this.form = { ...item };
      } else {
        this.form = {};
      }
    },
    saveOrUpdate() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }

        createContactWayState(this.form).then(() => {
          this.$message.success(this.form.id ? "修改成功" : "添加成功");
          this.visible = false;
          this.query();
        });
      });
    },
    deleteRecord(item) {
      this.$confirm("确认删除该记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delContactWayState(item.id).then(() => {
          this.$message.success("删除成功");
          this.query();
        });
      });
    },
    loadCampaignList() {
      listCampaign({}).then((res) => {
        this.campaignList = res.data;
      });
    },
    handleCampaignChange(campaignId) {
      const campaign = this.campaignList.find((item) => item.id === campaignId);
      if (campaign) {
        this.form.campaignTag = campaign.tag;
      }
    },
    handleCurrentChange(page) {
      this.query(page);
    }
  }
};
</script>

<style scoped>
.root-box {
  padding: 10px;
}

.query-container {
  margin-bottom: 20px;
}

.table {
  margin-bottom: 20px;
}

.page {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
